import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import { initSentry } from "./sentry";
import App from "./App";
import { ErrorBoundary } from "./components";
import * as Sentry from "@sentry/react";

initSentry();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Sentry.ErrorBoundary
   fallback={({ error, eventId, resetError }) => (
    <ErrorBoundary
     fullPage
     error={error}
     eventId={eventId}
     onReset={resetError}
    />
   )}
  >
   <App />
  </Sentry.ErrorBoundary>
);

reportWebVitals();
